import { Controller } from "@hotwired/stimulus"

export default class CloseWindowController extends Controller {
  static values = { returnUrl: String, name: String }

  connect() {
    window.opener?.Turbo.visit(this.returnUrlValue)
    if (window.name === this.nameValue) window.close()
    setTimeout(() => window.location.replace(this.returnUrlValue), 300)
  }
}
